import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { VerificationCheckConfiguration } from 'dashboard/forms/FormVerificationTemplateChecks/FormVerificationTemplateChecks';
import { DocumentRecencyCheckConfig } from 'dashboard/models/verification-check-config/document-recency-detection';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';
import { TextField } from 'design-system/components/FormField';
import { Paragraph } from 'design-system/components/Text';

const DEFAULT_REQUIRED_RECENCY_DAYS = 90;

interface DocumentRecencyConfigurationElementProps {
  checkConfig: DocumentRecencyCheckConfig;
  editable: boolean;
  handleUpdateCheck: (check: VerificationCheckConfig) => void;
}

const InlineConfigurationContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacing[2]};
  align-items: center;
`;

const StyledParagraph = styled(Paragraph)`
  text-wrap: nowrap;
`;

const StyledTextField = styled(TextField)`
  width: auto;
`;

// TODO: Clean this up after fully rolling out GA Readiness
export const DocumentRecencyConfigurationElement = ({
  checkConfig,
  editable,
  handleUpdateCheck,
}: DocumentRecencyConfigurationElementProps) => {
  const requiredRecencyDays = checkConfig['required-recency-days'];
  const handleUpdateRecencyDays = (recencyDays: number) => {
    handleUpdateCheck({
      ...checkConfig,
      'required-recency-days': recencyDays,
    } as DocumentRecencyCheckConfig);
  };
  let errorText;
  if (requiredRecencyDays != null) {
    if (requiredRecencyDays <= 0) {
      errorText = 'Required recency days must be greater than 0.';
    } else if (!Number.isInteger(requiredRecencyDays)) {
      errorText = 'Required recency days must be an integer.';
    }
  }
  return (
    <VerificationCheckConfiguration title='Number of days' disabled={!editable}>
      <TextField
        size='sm'
        type='number'
        value={requiredRecencyDays || ''}
        onChange={(e) => handleUpdateRecencyDays(+e.target.value)}
        errorText={errorText}
        disabled={!editable}
      />
    </VerificationCheckConfiguration>
  );
};

export const DocumentRecencyInlineConfigurationElement = ({
  checkConfig,
  editable,
  handleUpdateCheck,
}: DocumentRecencyConfigurationElementProps) => {
  const textStyleColor = !editable ? 'disabled' : null;
  const requiredRecencyDays = checkConfig['required-recency-days'];
  const handleUpdateRecencyDays = (recencyDays: number) => {
    handleUpdateCheck({
      ...checkConfig,
      'required-recency-days': recencyDays,
    } as DocumentRecencyCheckConfig);
  };
  let errorText;
  if (requiredRecencyDays != null) {
    if (requiredRecencyDays <= 0) {
      errorText = 'Must be greater than 0.';
    } else if (!Number.isInteger(requiredRecencyDays)) {
      errorText = 'Must be an integer.';
    }
  }

  // When check is turned off when in an errored state, reset the value to a default to ensure a valid configuration
  if (!editable && errorText) {
    handleUpdateRecencyDays(DEFAULT_REQUIRED_RECENCY_DAYS);
  }

  return (
    <InlineConfigurationContainer>
      <StyledParagraph color={textStyleColor} size='sm'>
        Number of days
      </StyledParagraph>
      <StyledTextField
        size='sm'
        type='number'
        value={requiredRecencyDays || ''}
        onChange={(e) => handleUpdateRecencyDays(+e.target.value)}
        errorText={errorText}
        disabled={!editable}
      />
    </InlineConfigurationContainer>
  );
};
